import React, { useEffect } from 'react';
import '../cs/temp.css';
import '../cs/te.css';
import AOS from "aos";
import 'aos/dist/aos.css'

function CloudComputing() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  })
  return (
    <div className="webdev-page" style={{ overflowX: "hidden" }}>
      {/* Banner */}
      <section className="inner-banner-wrap">
        <div
          className="inner-baner-container"
          style={{ backgroundImage: "url(assets/images/banner-pattern1.png)" }}
        >
          <div className="container">
            <div className="inner-banner-content">
              <h1 className="inner-title" data-aos="fade-up">Cloud Computing </h1>
            </div>
          </div>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="intro-section cloud-intro">
        <div className="container">
          <div className="intro-content">
            <div className="section-header text-left">
              <h2 data-aos="fade-up">Transform Your Business with Cloud Computing</h2>
              <p className="intro-text">
                At Codenix Infotech, we deliver end-to-end cloud computing solutions leveraging platforms like AWS, Azure, Google Cloud, and VMware. From strategy and migration to infrastructure design, security, and ongoing management, we ensure your business runs efficiently, securely, and at scale in the cloud.
              </p>
            </div>

          </div>
          <div className="intro-image cloud-graphic">

          </div>
        </div>
      </section>

      {/* Our Services Section */}
      <section className="webdev-services-section cloud-services">
        <div className="container">
          <div className="section-header">
            <h2>Our Cloud Computing Services</h2>
            <p className="section-description">
              Comprehensive cloud solutions to transform your IT infrastructure and business operations
            </p>
          </div>

          <div className="services-grid" data-aos="fade-up-left" data-aos-delay="200">
            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-exchange-alt"></i>
              </div>
              <h3>Cloud Migration</h3>
              <p>Seamlessly migrate your applications, workloads, and data to the cloud with minimal downtime and disruption.
                .</p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-server"></i>
              </div>
              <h3>Infrastructure Management</h3>
              <p>Design and manage scalable, high-performance cloud environments tailored to your business needs.
              </p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-shield-alt"></i>
              </div>
              <h3>Cloud Security</h3>
              <p>Implement robust security measures and compliance frameworks to safeguard sensitive data and applications.
              </p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-network-wired"></i>
              </div>
              <h3>Hybrid Cloud Solutions</h3>
              <p>Integrate on-premises infrastructure with cloud platforms for maximum flexibility and control.
              </p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-database"></i>
              </div>
              <h3>Cloud Database Services</h3>
              <p>Deploy, manage, and optimize cloud-based databases for high availability and performance.
              </p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-cogs"></i>
              </div>
              <h3>DevOps Automation</h3>
              <p>Streamline development and deployment workflows with cloud-based DevOps practices and CI/CD pipelines.
              </p>
            </div>
          </div>
        </div>
      </section>


      {/* Development Process Section */}
      <section className="design-process-section cloud-process">
        <div className="container">
          <div className="section-header">
            <h2>Our Cloud Computing Process</h2>
            <p className="section-description">
              A strategic approach to delivering scalable and secure cloud solutions tailored to your business
            </p>
          </div>

          <div className="process-timeline">
            {[
              {
                num: 1,
                title: "Cloud Strategy & Consulting",
                text: "We assess your goals and create a tailored roadmap for cloud adoption and optimization.                "
              },
              {
                num: 2,
                title: "Cloud Migration",
                text: "We ensure seamless migration with zero data loss and minimal business disruption.                "
              },
              {
                num: 3,
                title: "Infrastructure Setup",
                text: "We architect scalable, reliable cloud solutions to power your business operations.                "
              },
              {
                num: 4,
                title: "Cloud Management",
                text: "We provide ongoing monitoring, optimization, and resource management to reduce costs.                "
              },
              {
                num: 5,
                title: "Security Implementation",
                text: "We apply industry-standard encryption, access control, and compliance measures to protect your assets.                "
              },
              {
                num: 6,
                title: "Support & Maintenance",
                text: "We deliver round-the-clock support and optimization for smooth, efficient operations.                "
              }
            ].map((step) => (
              <div className="process-step" key={step.num} data-aos="fade-left" data-aos-delay="200">
                <div className="step-number">{step.num}</div>
                <div className="step-content">
                  <h3>{step.title}</h3>
                  <p>{step.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Cloud Platforms Section */}
      <section className="cloud-platforms-section">
        <div className="container">
          <div className="section-header">
            <h2>Cloud Platforms We Work With</h2>
            <p className="section-description">
              We leverage leading cloud platforms to deliver optimal solutions for your business
            </p>
          </div>

          <div className="services-grid" data-aos="fade-left" data-aos-delay="200">
            <div className="service-card platform-card">
              <div className="service-icon">
                <i className="fab fa-aws"></i>
              </div>
              <h3>Amazon Web Services</h3>
              <p>Comprehensive cloud services platform offering compute power, storage, and databases.</p>
            </div>

            <div className="service-card platform-card">
              <div className="service-icon">
                <i className="fab fa-microsoft"></i>
              </div>
              <h3>Microsoft Azure</h3>
              <p>Enterprise-grade cloud computing platform with integrated services and solutions.</p>
            </div>

            <div className="service-card platform-card d-none">
              <div className="service-icon">
                <i className="fab fa-google"></i>
              </div>
              <h3>Google Cloud Platform</h3>
              <p>Suite of cloud computing services running on Google's infrastructure.</p>
            </div>

            <div className="service-card platform-card">
              <div className="service-icon">
                <i className="fas fa-cloud"></i>
              </div>
              <h3>IBM Cloud</h3>
              <p>Open standards-based cloud platform for building, running, and managing applications.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Key Features Section */}
      <section className="design-principles-section cloud-features">
        <div className="container">
          <div className="section-header">
            <h2>Key Features of Our Cloud Solutions</h2>
            <p className="section-description">
              What makes our cloud computing services stand out from the rest
            </p>
          </div>

          <div className="services-grid" data-aos="fade-up-left" data-aos-delay="200">
            {[
              {
                icon: "fas fa-expand-arrows-alt",
                title: "Scalability",
                text: "Easily scale resources to meet growing demands."
              },
              {
                icon: "fas fa-dollar-sign",
                title: "Cost Efficiency",
                text: " Pay-as-you-go pricing helps optimize IT costs."
              },
              {
                icon: "fas fa-lock",
                title: "Enhanced Security",
                text: "Enterprise-grade encryption and compliance support."
              },
              {
                icon: "fas fa-globe",
                title: "Global Accessibility",
                text: "Access applications and data anywhere, anytime."
              },
              {
                icon: "fas fa-puzzle-piece",
                title: "Custom Solutions",
                text: "Cloud architectures designed for your business model"
              },
              {
                icon: "fas fa-headset",
                title: "Reliable Support",
                text: "Dedicated experts for continuous optimization."
              }
            ].map((feature, idx) => (
              <div className="service-card" key={idx}>
                <div className="service-icon">
                  <i className={feature.icon}></i>
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section mt-5 cloud-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Transform Your IT Infrastructure with Cloud?</h2>
            <p>Let's create scalable, secure, and efficient cloud solutions that drive innovation for your business.</p>
            <a href="/contact" className="cta-button">Get a Free Cloud Consultation</a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default CloudComputing;
